/* eslint-disable react-func/max-lines-per-function */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-params */

/**
 * Removes leading and trailing whitespaces inside markdown bold, ital and underline text, which
 * transormings invalid markdown such as **example ** into a valid one. Needed for react-rte
 * since it doesn't validate it. Handles all combination of bold+italic+underline.
 *
 * @param {string} str The string containing markdown to sanitize
 */
var sanitizeMarkdown = function sanitizeMarkdown(str) {
  var boldText = str ? str.match(/\s*(\*\*)\s*(.*?)\s*\1\s*/gm) : [];
  if (boldText && boldText.length) {
    boldText.map(function (text) {
      return text.trim();
    }).forEach(function (text) {
      var parts = text.match(/^\*{2,}(\s*)(.*?)(\s*)\*{2,}$/);
      if (parts) {
        str = str.replace(text, "".concat(parts[1], "**").concat(parts[2], "**").concat(parts[3]));
      }
    });
  }
  var underlineText = str ? str.match(/\s*(\+\+)\s*(.*?)\s*\1\s*/gm) : [];
  if (underlineText && underlineText.length) {
    underlineText.map(function (text) {
      return text.trim();
    }).forEach(function (text) {
      var parts = text.match(/^\+{2,}(\s*)(.*?)(\s*)\+{2,}$/);
      if (parts) {
        str = str.replace(text, "".concat(parts[1], "++").concat(parts[2], "++").concat(parts[3]));
      }
    });
  }
  var italicText = str ? str.match(/\s*(_)\s*(.*?)\s*\1\s*/gm) : [];
  if (italicText && italicText.length) {
    italicText.map(function (text) {
      return text.trim();
    }).forEach(function (text) {
      var parts = text.match(/^_(\s*)(.*?)(\s*)_$/);
      if (parts) {
        str = str.replace(text, "".concat(parts[1], "_").concat(parts[2], "_").concat(parts[3]));
      }
    });
  }
  return str;
};

/**
 * Transforms markdown from the rails markdown parser Redcarpet to a format
 * compatible with react-rte
 *
 * @param {string} str The string containing the markdown to pre process
 */
var preProcessMarkdown = function preProcessMarkdown(str) {
  if (typeof str !== 'string') {
    return str;
  }
  str = str.split('\n').map(function (str) {
    var newStr = '';
    var squareBracketOpen = false;
    var roundBracketOpen = false;
    var liquidVarOpen = false;
    for (var i = 0, len = str.length; i < len; i++) {
      var _char = str[i];
      var nextChar = str[i + 1];
      switch (_char) {
        case '\\':
          i++;
          if (squareBracketOpen || roundBracketOpen) {
            _char = nextChar;
          } else {
            _char += nextChar;
          }
          break;
        case '_':
          if (!roundBracketOpen && !liquidVarOpen) {
            _char = '++';
          }
          break;
        case '[':
          squareBracketOpen = true;
          break;
        case ']':
          squareBracketOpen = false;
          break;
        case '(':
          roundBracketOpen = true;
          break;
        case ')':
          roundBracketOpen = false;
          break;
        case '{':
          if (nextChar === '{' && !liquidVarOpen) {
            liquidVarOpen = true;
          }
          break;
        case '}':
          if (nextChar === '}' && liquidVarOpen) {
            liquidVarOpen = false;
          }
          break;
      }
      newStr += _char;
    }
    return newStr;
  }).join('\n');
  var italicUnderlineBoldRegex = /(\+{2}\*{3})([^\*\n\[\]()]*)(\*{3}\+{2})/g;
  str = replaceMarkdownSeparator(str, italicUnderlineBoldRegex, '*++**', '**++*');
  return str;
};

/**
 * Transforms markdown from react-rte to a format compatible with the rails
 * markdown parser Redcarpet
 *
 * @param {string} str The string containing the markdown to post process
 */
var postProcessMarkdown = function postProcessMarkdown(str) {
  if (typeof str !== 'string') {
    return str;
  }
  var charHandlerFunctions = {
    '\\': function _(i, _char2, nextChar, squareBracketOpen, roundBracketOpen) {
      if (squareBracketOpen || roundBracketOpen) {
        _char2 = nextChar;
      } else {
        _char2 += nextChar;
      }
      return {
        i: i + 1,
        "char": _char2
      };
    },
    _: function _(i, _char3, nextChar, squareBracketOpen, roundBracketOpen) {
      var blockOpen = squareBracketOpen || roundBracketOpen;
      return {
        i: i,
        "char": blockOpen ? _char3 : '*'
      };
    },
    '+': function _(i, _char4, nextChar, squareBracketOpen, roundBracketOpen) {
      if (!roundBracketOpen && nextChar === '+') {
        i++;
        _char4 = '_';
      }
      return {
        i: i,
        "char": _char4
      };
    },
    '*': function _(i, _char5, nextChar, squareBracketOpen, roundBracketOpen) {
      if (!squareBracketOpen || roundBracketOpen) {
        if (nextChar === '*') {
          i++;
          _char5 = '**';
        } else {
          _char5 = '*';
        }
      }
      return {
        i: i,
        "char": _char5
      };
    }
  };
  str = str.split('\n').map(function (str) {
    var newStr = '';
    var squareBracketOpen = false;
    var roundBracketOpen = false;
    for (var i = 0, len = str.length; i < len; i++) {
      var _char6 = str[i];
      var nextChar = str[i + 1];
      if (['\\', '_', '+', '*'].includes(_char6)) {
        var ret = charHandlerFunctions[_char6](i, _char6, nextChar, squareBracketOpen, roundBracketOpen);
        i = ret.i;
        _char6 = ret["char"];
      } else if (_char6 === '[') {
        squareBracketOpen = true;
      } else if (_char6 === '(') {
        roundBracketOpen = true;
      } else if (_char6 === ']') {
        squareBracketOpen = false;
      } else if (_char6 === ')') {
        roundBracketOpen = false;
      }
      newStr += _char6;
    }
    return newStr;
  }).join('\n');
  var italicUnderlineBoldRegex = /(\*_\*{2})([^\*\n\[\]()]*)(\*{2}_\*)/g;
  str = replaceMarkdownSeparator(str, italicUnderlineBoldRegex, '_***', '***_');
  return str;
};
var replaceMarkdownSeparator = function replaceMarkdownSeparator(str, regex, separator, separator2) {
  return str.replace(regex, function (match, start, content) {
    return "".concat(separator).concat(content).concat(separator2 || separator);
  });
};
export { postProcessMarkdown, preProcessMarkdown, sanitizeMarkdown };